import { INITIAL_CONFIG_DATA } from "../ConfigManager/services/constants";

export const moduleSlug = "CONFIG_MANAGER_LITE";

export const FORM_DATA = {
    ...INITIAL_CONFIG_DATA,
    start_request_configuration: {
        ...INITIAL_CONFIG_DATA.start_request_configuration,
        proxy_type_code: "PROXY_MANAGER",
        method: "GET",
        is_callback: false,
        use_cookie: false,
        allowed_content_types: [ "*/*" ]
    },
    worker: { count_workers: 20 }
};

export const EMPTY_TEMPLATE_SELECTOR = {
    condition_code: "CONTAINS",
    selector: "",
    source_code: "HTTP_RESPONSE_BODY",
    type_code: ""
};

export const EMPTY_TEMPLATE = {
    code: "",
    name: "",
    template_selectors: [],
    block_selectors: [],
    use_cache: false
};

export const DEFAULT_BLOCK_SELECTOR = {
    name: "Full page",
    is_required: true,
    source_code: "HTTP_RESPONSE_BODY",
    type_code: "NONE",
    condition_type_code: "ALL",
    selectors: [],
    data_selectors: []
};

export const QUICK_START_DATA = {
    //TODO: should be added for each env
    brand_code: "TEST_DEV",
    sandbox_mode: true,
    keyword: "test",
    debug_mode: true,
    store_http_response: true,
    disable_cache: true,
    trace_progress: true,
    metadata: {
        metadata_property: [
            {
                key: "DEEP_LEVEL",
                values: [ "5" ]
            }
        ]
    }
};

export const NORMALIZERS = [
    { code: "normalizer.prepend-domain-name-normalizer" },
    { code: "normalizer.remove-get-parameters-normalizer" }
];
